export default {"src":"/_next/static/image/public/images/ic_bookmark_dark_blue_vertical_menu.85db98b464d4112533affb4f15d3e9d6.svg","height":20,"width":20};